<template lang="pug">
  v-layout
    //-POPUP-ALERT
    PopupAlertMessage(
      @closeAlertPopup="actionPopupMethod($event)"
      :openPopup="popupAlert.openPopup"
      :image="popupAlert.image"
      :title="popupAlert.title"
      :message="popupAlert.message"
      :messageButton="popupAlert.messageButton"
      :buttonClose="popupAlert.buttonClose"
      :imgHeight="popupAlert.imgHeight"
      :imgWidth="popupAlert.imgWidth"
        )
    v-dialog(v-model="openPopupInfo" persistent width="300")
      v-card(style="display: flex;flex-direction: column;justify-content: center; border-radius:5px")
        v-card-text.pt-3.pb-1
          v-flex(style="text-align:center")
            span {{message}}
        v-card-actions.py-3
          v-flex(style="text-align:center")
            v-btn(@click="openPopupInfo=false" color="#EA0D90" style="width:10rem;height:2.7rem;border-radius:5px")
              span(style="color:#fff;text-transform:Capitalize" ) ok

    v-dialog(v-model="openPopup" fullscreen hide-overlay persistent transition='dialog-bottom-transition')
      v-card
        v-toolbar(dark color='primary')
          v-btn.btn-backspace(outline flat fab small @click="methodClosePopup")
            v-icon keyboard_backspace
          v-toolbar-title
            span(style="color: #ffffff; font-size: 20px;") Mis Beneficiarios
        v-card-text
          v-layout(column align-center)
            v-flex(mt-3 mb-4 style="text-align:center; width:18rem;")
              span.omnesMedium.beneficiaries-title {{ beneficiariosPrincipales.length > 0 ? 'Estos son tus beneficiarios actualmente' : 'Aquí podrás visualizar tus beneficiarios'}}
            v-flex(v-if="beneficiariosPrincipales.length === 0")
              v-img
                img(style="display:flex; margin:auto;" :src="iconNoBeneficiaries")
              p(v-if="!poliza.oriProducto.includes('VIDA_CASH_PLUS')").omnesMedium.g-text-center.no-beneficiaries-description En el caso de no contar con estos,
                br
                | puedes agregar tus beneficiarios desde aquí.
              p(v-if="poliza.oriProducto.includes('VIDA_CASH_PLUS')").omnesMedium.g-text-center.no-beneficiaries-description
                | Puedes agregar beneficiarios contactándonos con nuestro canales de comunicación, si aún no los has registrado.
            v-flex(v-if="beneficiariosPrincipales.length > 0" style="margin-bottom:2.5em auto;width: 17em;")
              v-layout(column)
                v-flex
                  v-layout(column)
                    v-flex(style="display: flex;align-items: center;")
                      span(style="font-size: 18px;line-height: 19px;color: #454A6C;margin-right:0.5em") Beneficiarios principales
                      img(
                        @click="popupInfo('main')"
                        style="height: 16px;"
                        :src="iconInterrogacion"
                        )
                    v-flex(style="width: fit-content;margin: 0.5em 0em;" v-for="(item, index) in beneficiariosPrincipales" :key="index")
                      TarjetaBeneficiarioIconDetalle(
                        :iconBeneficiario = "item.genero === 'hombre'? iconHombre : iconMujer"
                        :numeroBeneficiario = "index + 1"
                        :nombreBeneficiario = "item.nombre+' '+item.apellidoPaterno"
                        :porcentajeBeneficio = "item.porcentajeDistribucion")
                v-flex(v-if="beneficiariosContingentes.length >0" style="border-top: 1px solid #C9C9C9;margin:1.5em 0em")
                v-flex(v-if="beneficiariosContingentes.length >0")
                  v-layout(column)
                    v-flex(style="display: flex;align-items: center;")
                      span(style="font-size: 18px;line-height: 19px;color: #454A6C;margin-right:0.5em") Beneficiarios contingentes
                      img(
                        @click="popupInfo('')"
                        style="height: 16px; align-self: center;"
                        :src="iconInterrogacion"
                        )
                    v-flex(style="width: fit-content;margin: 0.5em 0em;" v-for="(item, index) in beneficiariosContingentes" :key="index")
                      TarjetaBeneficiarioIconDetalle(
                        :iconBeneficiario="item.genero === 'hombre'? iconHombre : iconMujer "
                        :numeroBeneficiario="index + 1"
                        :nombreBeneficiario="item.nombre+' '+item.apellidoPaterno"
                        :porcentajeBeneficio="item.porcentajeDistribucion"
                        :activo = "flag"
                        )

            v-flex(
              v-if="puedeCambiarBeneficiario"
              mt-5
              )
              v-btn.beneficiaries-button(@click="modificarBeneficiariosMethod" color="#EA0D90")
                span Modificar Beneficiario
            v-flex(mt-3 @click="methodClosePopup")
              span(style="font-size: 18px;color: #0855C4;")
                b Volver
            v-flex(v-if="!poliza.oriProducto.includes('VIDA_CASH_PLUS')" mt-4 style="text-align: justify; width:19em; line-height:15px")
              v-layout(row)
                v-flex(xs1 mr-1)
                  img(:src="iconAlerta")
                v-flex(v-if="puedeCambiarBeneficiario")
                  span(style="color: #919191;") Recuerda que los cambios se verán reflejados cuando la solicitud sea aprobada.
                v-flex(v-if="!puedeCambiarBeneficiario")
                  span(style="color: #919191;font-size:13px;") Si deseas modificar tus beneficiarios, por favor comunícate &nbsp;
                    a.omnesMedium(:href="links.WhatsApp" target="_blank" style="cursor:pointer;color:#919191") aquí
                    | .
</template>

<script>
import IconText from './../generic/IconText.vue'
import PopupAlertMessage from '../PopupAlertMessage.vue'
import TarjetaBeneficiarioIconDetalle from './../generic/TarjetaBeneficiarioIconDetalle.vue'
import {mapActions, mapGetters} from 'vuex'
import Links from '../../interfaces/links'
import Functionalities from '../../interfaces/functionalities'

export default {
  props: [
    'openPopup',
    'beneficiariosPrincipales',
    'beneficiariosContingentes',
    'puedeCambiarBeneficiario',
    'poliza',
    'taggeo'
  ],
  data () {
    return {
      links: Links,
      iconHombre: require('./../../assets/icons-mis-seguros/icon-beneficiario.svg'),
      iconMujer: require('./../../assets/icons-mis-seguros/icon-beneficiaria.svg'),
      iconInterrogacion: require('./../../assets/iconsv5/icon-question.svg'),
      iconAlerta: require('./../../assets/iconsv5/icon-alert.svg'),
      iconNoBeneficiaries: require('@/assets/icons-mis-seguros/icono-mi-agente2.svg'),
      flag: true,
      popupAlert: {
        openPopup: false,
        option: '',
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      },
      message: '',
      openPopupInfo: false
    }
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    methodClosePopup () {
      this.$emit('closePopup')
    },
    modificarBeneficiariosMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VIMDB, self.functionsRules, self)) {
        return
      }
      this.popupAlert.openPopup = true
      this.popupAlert.option = 'beneficiarios'
      this.popupAlert.title = 'Estimado cliente'
      this.popupAlert.message = this.puedeCambiarBeneficiario ? 'Te redireccionaremos a la solicitud modificación de beneficiarios...' : 'En estos momentos no puede realizar esta solicitud'
      this.popupAlert.messageButton = 'Entendido'
      this.popupAlert.buttonClose = this.puedeCambiarBeneficiario
    },
    actionPopupMethod (action) {
      if (action && this.puedeCambiarBeneficiario) {
        this.$router.push({ name: 'PerfilBeneficiarios',
          params: {
            policy: this.poliza.numeroPoliza,
            productName: this.poliza.producto,
            producto: this.poliza.ramo,
            subProducto: this.poliza.nombreProducto
          }
        })
          .then(data => {
            this.loader.flag = false
            this.popupAlert.openPopup = false
          }).catch(() => {
            this.popupAlert.openPopup = true
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.message = 'No hemos logrado ir a Modificación de Beneficiarios. Por favor, volver a intentarlo en unos minutos o comunicarse con nuestro Servicio de Atención al Cliente.'
            this.popupAlert.messageButton = 'Entendido'
            this.popupAlert.buttonClose = false

            this.loader.flag = false
          })
      }
      this.popupAlert.openPopup = false
    },
    popupInfo (type) {
      this.openPopupInfo = true
      switch (type) {
      case 'main':
        this.message = 'Los beneficiarios principales son las personas designadas para recibir el beneficio del seguro, en caso de fallecimiento del asegurado durante la vigencia de la póliza.'
        break
      default:
        this.message = 'El beneficiario contingente  es la persona o personas designadas para recibir el beneficio del seguro, en caso que el asegurado y él o los beneficiarios principales fallezcan durante la vigencia de la póliza.'
        break
      }
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules'])
  },
  mounted () {
    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Mis beneficiarios', metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'mis beneficiarios'
      }
    })
  },
  components: {
    TarjetaBeneficiarioIconDetalle,
    IconText,
    PopupAlertMessage
  }
}
</script>

<style scoped>
.beneficiaries-title {
  color: var(--first-brand-color);
  font-size: 20px;
  line-height: 1.1;
}

.no-beneficiaries-description {
  color: var(--text-color);
  font-size: 18px;
  line-height: 1.25;
  margin: 20px 0 0;
}

.beneficiaries-button {
  height: 4em;
  width: 19em;
}

.beneficiaries-button span {
  text-transform: initial;
  font-size: 16px;
  color: var(--white-color);
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/PopupMisBeneficiarios.vue